// export class FinanceCRModel {
//     cashreg_sequence: number;
//     client_no: number;
//     cashreg_clinic: number;
//     cashreg_date: string;
//     amount_of_pay: number;
//     method_of_pay: number;
//     check_card: string;
//     cashier: string;
//     cashreg_station: number;
//     cashreg_check: number;
//     invoice_no: number;
//     pet_no: number;

//     constructor(
//         cashreg_sequence: number,
//         client_no: number,
//         cashreg_clinic: number,
//         cashreg_date: string,
//         amount_of_pay: number,
//         method_of_pay: number,
//         check_card: string,
//         cashier: string,
//         cashreg_station: number,
//         cashreg_check: number,
//         invoice_no: number,
//         pet_no: number
//     ) {
//         this.cashreg_sequence = cashreg_sequence;
//         this.client_no = client_no;
//         this.cashreg_clinic = cashreg_clinic;
//         this.cashreg_date = cashreg_date;
//         this.amount_of_pay = amount_of_pay;
//         this.method_of_pay = method_of_pay;
//         this.check_card = check_card;
//         this.cashier = cashier;
//         this.cashreg_station = cashreg_station;
//         this.cashreg_check = cashreg_check;
//         this.invoice_no = invoice_no;
//         this.pet_no = pet_no;
//     }
// }

export class FinanceCRModel {
    inv_date: string;
    invoice_no: number;
    pet_no: number;
    actual_charge: number;
    total_charge: number;
    Discount: number;
    total_tax: number;
    prior_balance: number;
    balance_due: number;
    amount_paid: number;
    coupon: number;
    clinic_account: number;
    change: number;
    current_balance: number;
    deposit: number;
    ownership: number;
    payment_methods: string;
    pet_name: string;
    file_id: number;

    constructor(
        inv_date: string,
        invoice_no: number,
        pet_no: number,
        actual_charge: number,
        total_charge: number,
        Discount: number,
        total_tax: number,
        prior_balance: number,
        balance_due: number,
        amount_paid: number,
        coupon: number,
        clinic_account: number,
        change: number,
        current_balance: number,
        deposit: number,
        ownership: number,
        payment_methods: string,
        pet_name: string,
        file_id: number
    ) {
        this.inv_date = inv_date;
        this.invoice_no = invoice_no;
        this.pet_no = pet_no;
        this.actual_charge = actual_charge;
        this.total_charge = total_charge;
        this.Discount = Discount;
        this.total_tax = total_tax;
        this.prior_balance = prior_balance;
        this.balance_due = balance_due;
        this.amount_paid = amount_paid;
        this.coupon = coupon;
        this.clinic_account = clinic_account;
        this.change = change;
        this.current_balance = current_balance;
        this.deposit = deposit;
        this.ownership = ownership;
        this.payment_methods = payment_methods;
        this.pet_name = pet_name;
        this.file_id = file_id;
    }
}

